// src/components/CoverPage/CoverImage/styles.js
const styles = theme => ({
  root__bg: {
    display: 'flex',
    paddingTop: 0,
    flexDirection: 'column',
    width: '100%',
    maxWidth: '792px',
  },
  root__section: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'flex-start',
    gap: '0.7rem',
    flexDirection: 'column',
  },
  image__bg: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: 220,
    borderRadius: '12px',
    backgroundColor: '#fbfbfb',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    overflow: 'hidden',
  },
  image__icon: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: 100,
    height: 100,
    transform: 'translate(-50%, -50%)',
    opacity: 0.5,
    transition: '0.2s linear all',
    display: 'flex',
    justifyContent: 'center',
    gap: 5,
    alignItems: 'center',
    textAlign: 'center',
    flexDirection: 'column',
    '&:hover': {
      opacity: 1,
    },
  },
  image__span: {
    fontSize: '0.85rem',
    lineHeight: '0.75rem',
    fontWeight: '700',
    color: '#919EAB',
    width: '200px',
  },
  image__spanSecond: {
    fontSize: '0.55rem',
    lineHeight: '0.75rem',
    fontWeight: '700',
    color: theme.palette.grey[500],
    width: '100%',
  },
  image__content: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background:
        'linear-gradient(to bottom, rgba(0,0,0,0.15), rgba(0,0,0,0.15))',
      pointerEvents: 'none', // This ensures the overlay doesn't interfere with clicks
      zIndex: 1, // Add this to ensure the overlay is below the TextField
    },
  },
  image__remove: {
    position: 'absolute',
    right: 8,
    top: 8,
    zIndex: 999,
  },
  textfield: {
    '& fieldset': { border: 'none' },
    width: '75%',
    marginBottom: '12px',
    padding: 0,
    zIndex: 2, // Add this to ensure the TextField appears above the gradient
  },
  textfieldInput: {
    color: '#fff',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    textAlign: 'center',
    padding: 0,
  },
})

export default styles
